module.exports = __webpack_public_path__ + "img/dianhua.9b9877df.png";